import { HttpService } from '@/shared/services'
import { CalendarPeriodsGroupListDto } from '../models/CalendarPeriodsGroupListDto'
import List from '@/shared/dtos/List'
import {
  CreateCalendarPeriodGroupDto,
  GeneratePeriodsDto,
  UpdateCalendarPeriodGroupDto,
} from './dtos'
import { CalendarPeriod } from '../models/CalendarPeriod'
import { CalendarPeriodsGroup } from '../models/CalendarPeriodsGroup'

const http = new HttpService()

export const ListCalendarPeriodsGroups = async (
  payrollConfigId: string,
  search: string
) => {
  const { data } = await http.get<List<CalendarPeriodsGroupListDto[]>>(
    `/calendarPeriods/groups/${payrollConfigId}`,
    {
      params: {
        search,
      },
    }
  )
  return data
}

export const generatePeriods = async (dto: GeneratePeriodsDto) => {
  const formData = new FormData()

  if (dto.file) formData.append('file', dto.file)

  if (dto.initialDate)
    formData.append('initialDate', dto.initialDate.toString())

  if (dto.targetYear) formData.append('targetYear', dto.targetYear.toString())

  if (dto.frequency) formData.append('frequency', dto.frequency.toString())

  const { data } = await http.post<any, CalendarPeriod[]>(
    `/calendarPeriods/generate`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return data
}

export const deleteCalendarPeriodsGroup = async (id: string) => {
  const { data } = await http.delete(`/calendarPeriods/group/${id}`)
  return data
}

export const createCalendarPeriodsGroup = async (
  dto: CreateCalendarPeriodGroupDto
) => {
  const { data } = await http.post<CreateCalendarPeriodGroupDto, string>(
    `/calendarPeriods/group`,
    dto
  )
  return data
}

export const getCalendarPeriodsGroup = async (id: string) => {
  const { data } = await http.get<CalendarPeriodsGroup>(
    `/calendarPeriods/group-detail/${id}`
  )
  return data
}

export const updateCalendarPeriodsGroup = async (
  id: string,
  dto: UpdateCalendarPeriodGroupDto
) => {
  const { data } = await http.put<UpdateCalendarPeriodGroupDto, string>(
    `/calendarPeriods/group/${id}`,
    dto
  )
  return data
}
